import { MessageForm } from "./message_form";
import { MessagesList } from "./messages_list";
import { useGetMessagesQuery } from "../../redux/service/messages_service";
import { hasActionRights } from "../../userStore";
export const PatientMessages = props => {

    const {data: msgData, refetch: refetchMessages, isFetching: isFetchingMessages} = useGetMessagesQuery({type: 'message'});
    const defaultMessages = msgData?.meta?.default_messages || [];

    return (
        <>
            <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
                <h3 class="text-base font-semibold leading-6 text-gray-900">Messages</h3>
                <div className="text-right">
                    <button
                        type="button"
                        onClick={refetchMessages}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        Reload
                    </button>
                </div>
            </div>
            <div class="flex gap-4 p-3">
                <div className="w-6/12 h-msg-h overflow-auto">
                    <MessagesList msgData={msgData} refetchMessages={refetchMessages} isFetchingMessages={isFetchingMessages} />
                </div>
               {hasActionRights('messages','add')==1&& <div className="w-6/12 h-msg-h overflow-auto">
                    <MessageForm defaultMessages={defaultMessages} />
                </div>}
            </div>
        </>
    )
}